import PropTypes from 'prop-types';
import React from 'react';
import RowDisplay from '../../common/RowDisplay';
import { ProfileViewDetail } from '../../common/ProfileView/ProfileViewDetail';
import { ProfileViewRow } from '../../common/ProfileView/ProfileViewRow';
import { dateToEpoch, epochToDate } from '../../utils/epoch';
import { EditInsurance } from './EditInsurance';
import { ArchiveInsurance } from './ArchiveInsurance';
import { NcTracksVerification } from './NcTracks/NcTracksVerification';
export var PaymentsProfileView = function PaymentsProfileView(_ref) {
  var _insurance$plan$name, _insurance$plan, _insurance$external_m, _insurance$external_g;
  var contact = _ref.contact,
    insurance = _ref.insurance,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate,
    linkedScc = _ref.linkedScc;
  var planName = (_insurance$plan$name = (_insurance$plan = insurance.plan) === null || _insurance$plan === void 0 ? void 0 : _insurance$plan.name) !== null && _insurance$plan$name !== void 0 ? _insurance$plan$name : '';
  var startDate = insurance.enrolled_at;
  var endDate = insurance.expired_at;
  var convertDateStringToDisplayValue = function convertDateStringToDisplayValue(dateString) {
    return dateString ? epochToDate(dateToEpoch(dateString)) : '--';
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-information",
    "data-testid": "payments-profile-view"
  }, /*#__PURE__*/React.createElement(RowDisplay, {
    deleteSection: /*#__PURE__*/React.createElement(ArchiveInsurance, {
      contact: contact,
      insurance: insurance,
      linkedScc: linkedScc
    }),
    editSection: /*#__PURE__*/React.createElement(EditInsurance, {
      contactId: contact.id,
      insurance: insurance
    }),
    label: "Insurance",
    lastUpdate: insurance.ingested ? {
      recently_updated_at: insurance.updated_at
    } : lastUpdate,
    showLastUpdate: shouldShowLastUpdate,
    itemId: insurance.id,
    isInsuranceIngested: insurance.ingested
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow"
  }, /*#__PURE__*/React.createElement(ProfileViewRow, null, /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Plan Name",
    labelTestId: "insPlanNameKey",
    value: planName,
    valueTestId: "insPlanNameValue"
  }), /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Start Date",
    labelTestId: "insPlanStartDateKey",
    value: convertDateStringToDisplayValue(startDate),
    valueTestId: "insPlanStartDateValue"
  }), /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "End Date",
    labelTestId: "insPlanEndDateKey",
    value: convertDateStringToDisplayValue(endDate),
    valueTestId: "insPlanEndDateValue"
  }), /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Member ID",
    value: (_insurance$external_m = insurance.external_member_id) !== null && _insurance$external_m !== void 0 ? _insurance$external_m : ''
  }), /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Group ID",
    value: (_insurance$external_g = insurance.external_group_id) !== null && _insurance$external_g !== void 0 ? _insurance$external_g : ''
  })), /*#__PURE__*/React.createElement(NcTracksVerification, {
    insurance: insurance
  }))));
};
PaymentsProfileView.propTypes = {
  contact: PropTypes.object.isRequired,
  insurance: PropTypes.object.isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool,
  linkedScc: PropTypes.array
};
PaymentsProfileView.defaultProps = {
  lastUpdate: {
    recently_updated_at: null,
    recently_updated_by_name: null,
    versions: null
  },
  shouldShowLastUpdate: false
};
//# sourceMappingURL=PaymentsProfileView.js.map